import { render } from "./Header.vue?vue&type=template&id=8fbd64be&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=8fbd64be&scoped=true&lang=scss"

import exportComponent from "/var/www/test.adx-co.jp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fbd64be"]])

export default __exports__